import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import { FiCheck } from "react-icons/fi";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { withTranslation } from "react-i18next";

class About extends Component {
  render() {
    const { i18n } = this.props;
    // Check the current language
    const isEnglish = i18n.language === "en";

    return (
      <React.Fragment>
        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />
        <Breadcrumb title={isEnglish ? "About" : "A Propos"} />

        <div
          id="about_page"
          className="about-wrapper  pt--50 pb--50 bg_color--1"
        >
          <div className="container">
            <div className="row row--35 align-items-center">
              <div className="col-lg-12 col-md-12">
                <div className="about-inner inner">
                  {isEnglish ? (
                    <div className="section-title">
                      <h2 className="title">Global context & challenges</h2>
                      <p className="description">
                        Over the next two decades, Africa (particularly
                        sub-Saharan Africa) will experience a very strong
                        demographic surge, which should correspond to more than
                        860 million new city dwellers. The population and
                        surface area of cities will double in one generation.
                        This represents a major challenge, both spatially and
                        socially. While urbanization is a global trend, the
                        challenges will be greatest on the African continent.
                      </p>
                      <p className="description">
                        In addition, a new urban revolution - the digital
                        revolution - is profoundly transforming the way we
                        manage and design cities. It offers new opportunities
                        (new types of data (perception, real time, opinions,
                        ideas) and a new quantity of data (big urban data). For
                        example, over 90% of the world's data has been produced
                        in the last 2 years.
                      </p>
                      <p className="description">
                        The paradox is that when it comes to urban issues, vast
                        quantities of data are produced, but nobody - or almost
                        nobody - knows how to process it, or how to understand
                        its potential, so the tools are sorely lacking.
                      </p>
                      <p className="description">
                        The most innovative projects in the field of urban data
                        show a fascination for methods and technology, and
                        citizens are tending to drift further and further away:
                        ever more connected, but ever more distant. The social
                        question is a priority, and we need to put technology
                        back at the service of city-dwellers, not the other way
                        round.
                      </p>
                      <p className="description">
                        Currently, these digital issues for cities are taking
                        place in a context where professionals are poorly
                        structured, poorly trained and few in number, unable to
                        meet the growing challenges posed by digital
                        urbanization.
                      </p>
                      <p className="description">
                        The city is therefore cruelly lacking in reflection,
                        professionals, tools and innovation, even though it is
                        one of the main drivers of the world's economic
                        dynamism. Traditional urban management will soon be
                        outdated and a need for reinvention is necessary. New
                        professions are appearing without cities being able to
                        take them into account in their practice.
                      </p>
                      <h4 className="">Specific Objectives : </h4>
                      <div className="description description_list mt-4">
                        <ul style={{ paddingLeft: "18px" }}>
                          <li>
                            To train the future actors of the city capable of
                            responding to the challenges that await the
                            professionals of space in a digital revolution.
                          </li>
                          <li>
                            To become the place of reflection on current and
                            future Moroccan cities and on the entire African
                            continent.
                          </li>
                          <li>
                            Promote excellence in urban systems engineering by
                            structuring the actors in the field.
                          </li>
                        </ul>
                        <p className="font-weight-bold">
                          To achieve the objectives, it is necessary to first :
                        </p>
                        <ul className="mt-2">
                          <li>
                            Establish the ecosystem necessary for a center of
                            urban studies.
                          </li>
                          <li>Train future teachers.</li>
                          <li>Position itself on the international scene.</li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div className="section-title">
                      <h2 className="title">Contexte mondial et défis</h2>
                      <p className="description">
                        Au cours des deux prochaines décennies, l'Afrique (en
                        particulier l'Afrique subsaharienne) connaîtra une très
                        forte poussée démographique, qui devrait correspondre à
                        plus de 860 millions de nouveaux citadins. La population
                        et la superficie des villes doubleront en une
                        génération. Il s'agit là d'un défi majeur, tant sur le
                        plan spatial que social. Si l'urbanisation est une
                        tendance mondiale, c'est sur le continent africain que
                        les défis seront les plus importants.
                      </p>
                      <p className="description">
                        Par ailleurs, une nouvelle révolution urbaine - la
                        révolution numérique - transforme profondément la façon
                        dont nous gérons et concevons les villes. Elle offre de
                        nouvelles opportunités (nouveaux types de données
                        (perception, temps réel, opinions, idées) et une
                        nouvelle quantité de données (big urban data). Par
                        exemple, plus de 90 % des données mondiales ont été
                        produites au cours des deux dernières années.
                      </p>
                      <p className="description">
                        Le paradoxe est que lorsqu'il s'agit de questions
                        urbaines, de grandes quantités de données sont
                        produites, mais personne - ou presque - ne sait comment
                        les traiter, ni comment comprendre leur potentiel, de
                        sorte que les outils font cruellement défaut.
                      </p>
                      <p className="description">
                        Les projets les plus innovants dans le domaine des
                        données urbaines montrent une fascination pour les
                        méthodes et la technologie, et les citoyens ont tendance
                        à s'éloigner de plus en plus : toujours plus connectés,
                        mais toujours plus distants. La question sociale est
                        prioritaire et il faut remettre la technologie au
                        service des citadins et non l'inverse.
                      </p>
                      <p className="description">
                        Actuellement, ces enjeux numériques pour les villes
                        s'inscrivent dans un contexte où les professionnels sont
                        peu structurés, peu formés et peu nombreux, incapables
                        de répondre aux défis croissants posés par
                        l'urbanisation numérique.
                      </p>
                      <p className="description">
                        La ville manque donc cruellement de réflexion, de
                        professionnels, d'outils et d'innovation, alors qu'elle
                        est l'un des principaux moteurs du dynamisme économique
                        mondial. La gestion urbaine traditionnelle sera bientôt
                        dépassée et un besoin de réinvention est nécessaire. De
                        nouveaux métiers apparaissent sans que les villes
                        puissent les prendre en compte dans leur pratique.
                      </p>
                      <h4 className="">Objectifs spécifiques :</h4>
                      <div className="description mt-4">
                        <ul style={{ paddingLeft: "18px" }}>
                          <li>
                            Former les futurs acteurs de la ville capables de
                            répondre aux défis qui attendent les professionnels
                            de l'espace dans une révolution numérique.
                          </li>
                          <li>
                            Devenir le lieu de réflexion sur les villes
                            marocaines actuelles et futures et sur l'ensemble du
                            continent africain.
                          </li>
                          <li>
                            Promouvoir l'excellence dans l'ingénierie des
                            systèmes urbains en structurant les acteurs du
                            domaine.
                          </li>
                        </ul>
                        <p className="font-weight-bold">
                          Pour atteindre les objectifs, il faut tout d'abord :
                        </p>
                        <ul className="mt-2">
                          <li>
                            Mettre en place l'écosystème nécessaire à un centre
                            d'études urbaines.
                          </li>
                          <li>Former les futurs enseignants.</li>
                          <li>Se positionner sur la scène internationale.</li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="rn-about-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image bg_image--18"
          data-black-overlay="5"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="inner">
                  <div className="content-wrapper">
                    <div className="content">
                      <div className="section-title">
                        <span className="subtitle">
                          {" "}
                          {isEnglish ? "About" : "A Propos"}
                        </span>
                        <h2 className="title">
                          {" "}
                          {isEnglish ? "About" : "A Propos"}
                        </h2>
                      </div>
                      <div className="row mt--30">
                        <div>
                          <div className="tabs-area">
                            <div className="container">
                              <div className="row">
                                <div className="col-lg-12">
                                  <Tabs>
                                    <TabList
                                      style={{ flexWrap: "inherit" }}
                                      className="tab-style--1"
                                    >
                                      <Tab className="w-100 text-center">
                                        {isEnglish ? "Objectives" : "Objectifs"}
                                      </Tab>
                                      <Tab className="w-100 text-center">
                                        Mission
                                      </Tab>
                                      <Tab className="w-100 text-center">
                                        Vision
                                      </Tab>
                                    </TabList>
                                    <TabPanel>
                                      <div className="single-tab-content">
                                        <div className="mt--30 mt_lg--10 mt_md--10 mt_sm--10">
                                          <h4>
                                            {isEnglish
                                              ? "Objectives"
                                              : "Objectifs"}
                                          </h4>
                                          <div className="description">
                                            {isEnglish ? (
                                              <ul
                                                style={{ paddingLeft: "18px" }}
                                              >
                                                <li>
                                                  Change the angle of view of
                                                  urban studies research in
                                                  Africa, i.e., resolutely
                                                  position research in the
                                                  digital, data, and
                                                  quantitative fields, but with
                                                  a societal viewpoint, which
                                                  gives it added value compared
                                                  to other research on the
                                                  continent and in the
                                                  discipline of urban studies.
                                                </li>
                                                <li>
                                                  To test new methods and put
                                                  big data at the centre of
                                                  reflections on the resolution
                                                  of complex urban problems, and
                                                  thus gain visibility through
                                                  innovative methods.
                                                </li>
                                                <li>
                                                  Position on the polytechnic
                                                  vision as a central element of
                                                  the centre.
                                                </li>
                                                <li>
                                                  CUS's objectives include
                                                  training future urban players,
                                                  reflecting on cities in
                                                  Morocco and Africa, and
                                                  promoting excellence in urban
                                                  systems engineering.
                                                </li>
                                              </ul>
                                            ) : (
                                              <ul
                                                style={{ paddingLeft: "18px" }}
                                              >
                                                <li>
                                                  Changer l'angle de vue de la
                                                  recherche en études urbaines
                                                  en Afrique, c'est-à-dire
                                                  positionner résolument la
                                                  recherche dans les domaines du
                                                  numérique, des données et du
                                                  quantitatif, mais avec un
                                                  regard sociétal, ce qui lui
                                                  confère une valeur ajoutée par
                                                  rapport aux autres recherches
                                                  sur le continent et dans la
                                                  discipline des études
                                                  urbaines.
                                                </li>
                                                <li>
                                                  Tester de nouvelles méthodes
                                                  et mettre le big data au
                                                  centre des réflexions sur la
                                                  résolution de problèmes
                                                  urbains complexes, et ainsi
                                                  gagner en visibilité grâce à
                                                  des méthodes innovantes.
                                                </li>
                                                <li>
                                                  Se positionner sur la vision
                                                  polytechnique comme élément
                                                  central du centre.
                                                </li>
                                                <li>
                                                  Les objectifs de CUS
                                                  comprennent la formation des
                                                  futurs acteurs urbains, la
                                                  réflexion sur les villes du
                                                  Maroc et de l'Afrique, et la
                                                  promotion de l'excellence dans
                                                  l'ingénierie des systèmes
                                                  urbains.
                                                </li>
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </TabPanel>
                                    <TabPanel>
                                      <div className="single-tab-content">
                                        <div className="mt--30 mt_lg--10 mt_md--10 mt_sm--10">
                                          <h4>Mission</h4>
                                          {isEnglish ? (
                                            <>
                                              <p>
                                                CUS is a center dedicated to
                                                research, education, and
                                                innovation in urban science. It
                                                uses Living Labs as a research
                                                and classroom environment to
                                                train future urban leaders and
                                                find innovative solutions to
                                                complex urban problems. CUS
                                                focuses on four pillars:
                                                research, education, expertise,
                                                and innovation, all aimed at
                                                improving urban management and
                                                citizen well-being.
                                              </p>
                                              <p>
                                                CUS transforms data collected by
                                                Living Labs to make them
                                                sustainable, viable, supportive,
                                                and cost-effective.
                                              </p>
                                              <p>
                                                CUS will train the next
                                                generation of urban systems
                                                engineers.
                                              </p>
                                            </>
                                          ) : (
                                            <>
                                              <p>
                                                Le CUS est un centre dédié à la
                                                recherche, à l'éducation et à
                                                l'innovation dans le domaine des
                                                sciences urbaines. Elle utilise
                                                les Living Labs comme
                                                environnement de recherche et de
                                                formation pour former les futurs
                                                leaders urbains et trouver des
                                                solutions innovantes à des
                                                problèmes urbains complexes. Le
                                                CUS se concentre sur quatre
                                                piliers : la recherche,
                                                l'éducation, l'expertise et
                                                l'innovation, qui visent tous à
                                                améliorer la gestion urbaine et
                                                le bien-être des citoyens.
                                              </p>
                                              <p>
                                                Le CUS transforme les données
                                                collectées par les Living Labs
                                                pour les rendre durables,
                                                viables, soutenables et
                                                économiques.
                                              </p>

                                              <p>
                                                La CUS formera la prochaine
                                                génération d'ingénieurs en
                                                systèmes urbains.
                                              </p>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </TabPanel>
                                    <TabPanel>
                                      <div className="single-tab-content">
                                        <div className="mt--30 mt_lg--10 mt_md--10 mt_sm--10">
                                          <h4>Vision</h4>
                                          {isEnglish ? (
                                            <>
                                              <p>
                                                CUS aims to become a leader in
                                                education, research, and
                                                innovation in urban science,
                                                using Living Labs to train
                                                future urban leaders and find
                                                innovative solutions to complex
                                                urban problems. The CUS seeks to
                                                improve urban management and
                                                citizen well-being by
                                                transforming data collected by
                                                the Living Labs to make them
                                                sustainable, viable, supportive,
                                                and cost-effective. It will also
                                                strive to train the next
                                                generation of urban systems
                                                engineers, stimulate thinking
                                                about Morocco and Africa's
                                                cities, and promote excellence
                                                in urban systems engineering. To
                                                achieve these goals, CUS must
                                                create an ecosystem for a school
                                                of urban systems, train future
                                                teachers, and position itself on
                                                the international stage.
                                              </p>
                                              <p>
                                                Our vision integrates theory,
                                                project management, expertise,
                                                and innovation, focusing on the
                                                contemporary challenges of urban
                                                development. This integration
                                                not only encompasses urban
                                                innovation but also extends to
                                                innovative approaches in
                                                teaching, thus aligning with the
                                                digital, data-driven, and
                                                quantitative focus of urban
                                                studies research in Africa.
                                              </p>
                                            </>
                                          ) : (
                                            <>
                                              <p>
                                                Le CUS a pour objectif de
                                                devenir un leader en matière
                                                d'éducation, de recherche et
                                                d'innovation dans le domaine des
                                                sciences urbaines, en utilisant
                                                les Living Labs pour former les
                                                futurs dirigeants urbains et
                                                trouver des solutions innovantes
                                                à des problèmes urbains
                                                complexes. Le centre cherche à
                                                améliorer la gestion urbaine et
                                                le bien-être des citoyens en
                                                transformant les données
                                                collectées par les Living Labs
                                                pour les rendre durables,
                                                viables, solidaires et
                                                rentables. Il s'efforcera
                                                également de former la prochaine
                                                génération d'ingénieurs en
                                                systèmes urbains, de stimuler la
                                                réflexion sur les villes
                                                marocaines et africaines et de
                                                promouvoir l'excellence dans
                                                l'ingénierie des systèmes
                                                urbains. Pour atteindre ces
                                                objectifs, le CUS doit créer un
                                                écosystème pour une école des
                                                systèmes urbains, former les
                                                futurs enseignants et se
                                                positionner sur la scène
                                                internationale.
                                              </p>
                                              <p>
                                                Notre vision intègre la théorie,
                                                la gestion de projet,
                                                l'expertise et l'innovation, en
                                                se concentrant sur les défis
                                                contemporains du développement
                                                urbain. Cette intégration
                                                n'englobe pas seulement
                                                l'innovation urbaine mais
                                                s'étend également aux approches
                                                innovantes dans l'enseignement,
                                                s'alignant ainsi sur
                                                l'orientation numérique, axée
                                                sur les données et quantitative
                                                de la recherche en études
                                                urbaines en Afrique.
                                              </p>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </TabPanel>
                                  </Tabs>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rn-service-details ptb--120 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="service-details-inner">
                  <div className="inner">
                    <div className="row row--35 sercice-details-content align-items-center">
                      <div className="col-lg-6 col-12">
                        <div className="thumb position-relative">
                          <img
                            className="w-100"
                            src="/assets/images/about/image2.jpg"
                            alt="About Images"
                            style={{ height: "500px", objectFit: "cover" }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="details mt_md--30 mt_sm--30">
                          <div className="section-title">
                            <span className="subtitle">
                              {isEnglish
                                ? "Research topics"
                                : "Thématiques de recherche"}
                            </span>
                            <h2 className="title">
                              {isEnglish
                                ? "Research topics"
                                : "Thématiques de recherche"}
                            </h2>
                            <p className="description">
                              {isEnglish
                                ? "The topics of the CUS, in a non-exhaustive way :"
                                : "Les sujets du CUS, de manière non exhaustive :"}
                            </p>
                          </div>
                          <ul className="liststyle mt--30">
                            <li>Digital development</li>
                            <li>Resilient infrastructure</li>
                            <li>Smart and sustainable cities</li>
                            <li>Smart mobility and transportation</li>
                            <li>Smart energy systems</li>
                            <li>Health and comfort inside buildings</li>
                            <li>Food security and Urban agriculture</li>
                            <li>Spatial public health</li>
                            <li>Environmental modeling and monitoring</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-area pb--60 pt--0">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center mb--30">
                  <span className="subtitle">Pillars</span>
                  <h2>Pillars</h2>
                </div>
              </div>
            </div>
            <img src="/assets/images/about/pillars.png" />
          </div>
        </div>

        <div className="rn-service-details ptb--60 bg_color--5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="service-details-inner">
                  <div className="inner">
                    <div className="row row--35 sercice-details-content align-items-center">
                      <div className="col-lg-6 col-12">
                        <div className="details">
                          <div className="section-title">
                            <span className="subtitle">Outcome</span>
                            <h2 className="title">Outcome</h2>
                          </div>
                          <ul className="list-style--1 mt--30">
                            <li>
                              <FiCheck /> New collaborative policies for
                              territorial development, mobility, health
                            </li>
                            <li>
                              <FiCheck /> Production of a new standard in urban
                              data
                            </li>
                            <li>
                              <FiCheck /> Innovation and global excellence in
                              the field of urban studies
                            </li>
                            <li>
                              <FiCheck /> Contribute to the dynamics of human
                              development of Moroccan and African society
                            </li>
                            <li>
                              <FiCheck /> The Center becomes a continental
                              leader in the development of urban management
                              products
                            </li>
                            <li>
                              <FiCheck /> The center is an international
                              platform where African researchers, but also from
                              other continents, will come to spend a few weeks,
                              months or even years in a stimulating environment
                            </li>
                            <li>
                              <FiCheck /> Training of high level researchers who
                              will be able to teach in the future School of
                              urban systems and in other universities.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-6 col-12 mt_md--30 mt_sm--30">
                        <div className="thumb position-relative">
                          <img
                            className="w-100"
                            style={{ height: "500px", objectFit: "cover" }}
                            src="/assets/images/about/image1.jpg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>

        <Footer />
      </React.Fragment>
    );
  }
}
export default withTranslation()(About);
